export default class CoursesSearch {

	static init() {
		return new CoursesSearch();
	}

	constructor() {
		const container = document.querySelector('.courses-search');
		if (!container)
			return;
			
		const loadMoreProgress = container.querySelector('.load-more-progress');
		let loadMoreEnabled = true;

		window.addEventListener('scroll', () => {
			if (loadMoreEnabled && container && container.getBoundingClientRect().bottom < window.innerHeight - 50) {
				window.livewire.emit('load-more');
				loadMoreProgress.classList.add('loading');
				loadMoreEnabled = false;
			}
		});

		window.livewire.hook('element.updated', (el, component) => {
			loadMoreEnabled = true;
			loadMoreProgress.classList.remove('loading');
		});
	}
}
